import { Option } from '../../Crud/filters/components/MultiOptionsSelectorFilter/components/MultiOptionsSelector/components/OptionsList/optionsList.types';
import { OptionValue } from '../../FormInputs/MultiOptionsSelectorV2/components/OptionsList/optionsList.types';

export const getMultiOptionFriendlyLabel = (
  options: Option[],
  selectedOptions: OptionValue[],
): string[] => {
  const allLabels = options.reduce((acc: string[], option) => {
    const finalLabel = option.chipLabel || option.label;

    if (option.children) {
      const selectedChildren = option.children.filter((child) =>
        selectedOptions.includes(child.value),
      );
      const hasSelectedChildren = selectedChildren.length > 0;
      const hasChildren = option.children.length > 0;
      const hasChildrenAndSelectedChildren = hasChildren && hasSelectedChildren;

      if (hasChildrenAndSelectedChildren && selectedChildren.length === option.children.length) {
        acc.push(finalLabel?.split('\n')[0] || '');
      } else {
        selectedChildren.forEach((child) => {
          acc.push(child.label?.split('\n')[0] || '');
        });
      }
    }

    if (selectedOptions.includes(option.value)) {
      acc.push(finalLabel?.split('\n')[0] || '');
    }

    return acc;
  }, []);

  return allLabels;
};
